export const DownToBottom = `<svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M25.3648 7.30042L15.9546 16.598L6.63523 7.33389" stroke="currentColor" stroke-width="2"/>
<path d="M4 23H28" stroke="currentColor" stroke-width="2"/>
</svg>`;
